import React from "react";
import PropTypes from "prop-types";
import Button from "material-ui/Button";
import localizeIcon from "../../../../icons/localize.svg";

const GeolocationButton = props => (
  <Button
    style={{
      padding: "0 5px 0 5px",
      margin: "10px 0 0 0",
      ...props.isVisible
    }}
    color="primary"
    onClick={() => {
      if ("geolocation" in navigator) {
        props.displayLoading();
        if (props.lastUserPosition) {
          props.updateAdress(null, props.lastUserPosition);
        } else {
          navigator.geolocation.getCurrentPosition(
            position => {
              props.updateAdress(null, [
                position.coords.longitude,
                position.coords.latitude
              ]);
            },
            error => {
              props.displayLoading();
            },
            { timeout: 6000, enableHighAccuracy: true, maximumAge: 0 }
          );
        }
      }
    }}
  >
    <img style={{ marginRight: "10px" }} alt="localize" src={localizeIcon} />
    Me localiser
  </Button>
);

GeolocationButton.propTypes = {
  isVisible: PropTypes.shape().isRequired,
  updateAdress: PropTypes.func.isRequired,
  displayLoading: PropTypes.func.isRequired,
  lastUserPosition: PropTypes.array
};

export default GeolocationButton;



// WEBPACK FOOTER //
// ./src/containers/MainCard/TabsCard/GeolocationButton/GeolocationButton.jsx